// 埋点相关
import TrackLandingController from './landing-track';
import TrackClassChooseController from './class-choose-track';
import TrackResultController from './result-track';

export { TrackLandingController, TrackClassChooseController, TrackResultController };
